import type { ChatHistoryLine } from "@redotech/redo-merchant-app-common/escalation";
import type { AskRedoUIMessage } from "../types";
import { humanMessageId, userReplyMessageId } from "./intercom-to-uimessage";

/**
 * Adapter from the AskRedoUIMessage[] in the chat to the chat-history
 * payload `createEscalation` expects. Skips Intercom-side messages
 * that were injected into the UI (they're already in the Intercom
 * conversation we'd reuse on re-escalation, so re-sending them would
 * duplicate). Skips reasoning / dynamic-tool parts — they're internal
 * agent state, not user-readable transcript content.
 */
export function buildAskRedoChatHistory(
  messages: AskRedoUIMessage[],
): ChatHistoryLine[] {
  const lines: ChatHistoryLine[] = [];

  for (const message of messages) {
    if (
      message.id.startsWith(humanMessageId("")) ||
      message.id.startsWith(userReplyMessageId(""))
    ) {
      continue;
    }
    if (message.role !== "user" && message.role !== "assistant") {
      continue;
    }
    const content = extractText(message);
    if (!content) {
      continue;
    }
    lines.push({ id: message.id, role: message.role, content });
  }

  return lines;
}

function extractText(message: AskRedoUIMessage): string {
  const chunks: string[] = [];
  for (const part of message.parts) {
    if (part.type === "text" && part.text.length > 0) {
      chunks.push(part.text);
    }
  }
  return chunks.join("\n").trim();
}
